import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { selectDefectCodesToEdit } from "../../store/selectors/defectSelectors";
import { setToEditDefectCodes, updateItem } from "../../store/slices/defectSlice";
import { DefectCodeDialog } from "./DefectCodeDialog";
import { updateDefect } from "../../services/defectService";

export const EditDefectCodeDialog = () => {
    const dispatch = useAppDispatch();

    const toEdit = useAppSelector(selectDefectCodesToEdit);

    if (!toEdit) {
        return null;
    }

    const onSubmit = async (typeCode: string | null, codeAssignReason?: string | null) => {
        const defect = {
            ...toEdit,
            typeCode,
            codeAssignReason
        };

        const updated = await updateDefect(defect);

        if (updated) {
            dispatch(updateItem(defect));
        }
    }

    const onHide = () => {
        dispatch(setToEditDefectCodes(undefined));
    };

    return <DefectCodeDialog 
        onSubmit={onSubmit} 
        visible={!!toEdit} 
        onHide={onHide} 
        currentTypeCode={toEdit?.typeCode}
    />;
}